const statisticsData = [
  {
    title: 23,
    description: "Years of experience on orphan vulnerable children",
  },
  {
    title: 86871,
    description: "People living with HIV AIDS served since 2000",
  },
  {
    title: 73,
    description: "Towns of Ethiopia has been covered since its start",
  },
  {
    title: 27000,
    description: "Orphan vulnerable children has been served",
  },
];

export default statisticsData;
